import * as React from "react";
import styled from 'styled-components';
import * as _ from "lodash";
import SigImage from "../images/sig.png";
import {Image} from "semantic-ui-react";
import {actionCreators} from "../store/Customer";
import {ApplicationState} from "../store";
import {connect} from "react-redux";
import {Component} from "react";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import throttle from "lodash.throttle"
import {Spinner} from "reactstrap";
import {ccaHandlerAPIUrl} from "../index";

import 'bootstrap/dist/css/bootstrap.min.css';

//type CCAViewerProps = typeof actionCreators & React.Props<{}> & { customer: CustomerState, setCustomerTelephoneNo: () => void };
type CCAViewerProps = React.Props<{}> & { setCustomerTelephoneNo: (tel:string) => void };

export class CCAViewer extends Component<CCAViewerProps> {

  

  
  state = {
    loading:true,
    pdfDoc:null,
    pdfLoaded:false,
    pdfFilename:"",
    customerName:"",
    policyCreateDate:"",
    creditLimit:0.0,
    totalBorrowed:0.0,
    interestAmount:0.0,
    interestRate:0.0,
    loanAmount:0.0,
    numPages: 0,
    tel:"01603 218000",
    width:null,
    termsTicked:false,
    showCancelContent:false,
    showSignedContent:false,
    showAlreadySignedContent:false,
    showInvalidPolicyContent:false,
    uniqueRef:null
  };
  
    
  componentDidMount() {
    
    //this.setDivSize()
    window.addEventListener("resize", throttle(this.setDivSize, 500))
    
    const uniqueRef = this.props["match"].params["uniqueRef"]
    if (uniqueRef)
    {
      this.getPolicyInformation(uniqueRef);
    }
    else {
      this.setState({showInvalidPolicyContent:true, loading:false}, () =>{window.scrollTo(0, 0);});
    }

    window.scrollTo(0, 0);

  }
  
  componentWillUnmount () {
    window.removeEventListener("resize", throttle(this.setDivSize, 500))
  }

  setDivSize = () => {
    if (!this.state.loading) {
      if (document.getElementById("pdfWrapper")) {
        this.setState({width: document.getElementById("pdfWrapper").getBoundingClientRect().width});
      }
    }
  }
  
  setNumPages = (numPages) => {
    this.setState({numPages:numPages});
  }
  
  getPolicyInformation = (uniqueRef) => {
    this.setState({ loading: true, uniqueRef: uniqueRef }, async () => {
      
      const response = await fetch(`${ccaHandlerAPIUrl}/api/cca/${uniqueRef}`);
      
      const json = await response.json();

      if (json.reason) {
        this.setState({ showInvalidPolicyContent: true, loading: false }, () => { window.scrollTo(0, 0); });
      }
      else {
        if (json.details) {
          let result = json.details.filter(function (deets) {
            return deets.key === "result"
          });

          if (result && result[0].value === "OK") {
            for (let i = 0; i < json.details.length; i++) {
              let entry = json.details[i];

              switch (entry.key) {
                case "creditLimit":
                  this.setState({ creditLimit: entry.value });
                  break;
                case "totalBorrowed":
                  this.setState({ totalBorrowed: entry.value });
                  break;
                case "interestAmount":
                  this.setState({ interestAmount: entry.value });
                  break;
                case "interestRate":
                  this.setState({ interestRate: entry.value });
                  break;
                case "loanAmount":
                  this.setState({ loanAmount: entry.value });
                  break;
                case "customerName":
                  this.setState({ customerName: entry.value });
                  break;
                case "policyCreateDate":
                  this.setState({ policyCreateDate: entry.value });
                  break;
                case "tel":                  
                  this.props.setCustomerTelephoneNo(entry.value);
                  break;
              }
            }

            let pdfData = json.documents[0].data;
            let pdfFilename = json.documents[0].name;
            
            this.setState({ pdfDoc: pdfData, pdfFilename: pdfFilename, loading: false }, () => { this.setDivSize(); window.scrollTo(0, 0); });

          }
          if (result && result[0].value === "SIGNED") {
            this.setState({ showAlreadySignedContent: true, loading: false }, () => { window.scrollTo(0, 0); });
          }
        }
      }
    });
  }

  termTickAction= () => {
    let currentTermsTickedState = this.state.termsTicked;
    this.setState({termsTicked:!currentTermsTickedState});
  }
  
  okAction= async () => {

    let data = {
      "PolicyRef":this.state.pdfFilename,
      "UniqueReference":this.state.uniqueRef
    }
    console.log("Sending",data);
    fetch(`${ccaHandlerAPIUrl}/api/cca`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      console.log(response);
      response.json().then((json) => {
        if (json && json.status && json.status === "OK")
        {
          this.setState({showSignedContent: true},() =>{window.scrollTo(0, 0);});
        }
      });
    });   
    
  }
  
  cancelAction= () => {
    this.setState({showCancelContent:true},() =>{window.scrollTo(0, 0);});
  }
  
  render() {     
    return (
        <React.Fragment>
          {this.state.loading &&
            <SpinnerContainer>
              <Spinner animation="border" children={""}/>&nbsp;&nbsp;Please wait while we load your agreement...
            </SpinnerContainer>
          }
          
          {!this.state.loading 
          && this.state.showCancelContent === false 
          && this.state.showSignedContent === false
          && this.state.showAlreadySignedContent === false
          && this.state.showInvalidPolicyContent === false
          &&
          <div style={{paddingBottom: '2em', paddingLeft: '16px', paddingRight: '16px', paddingTop: '2em'}}>
            <CartSummary>
              <section id="order-summary">
                <div className="container">
                  <div className="summary-row">
                    <div className="container-title">Your order</div>
                  </div>

                  <div>
                    <div className="summary-row" key="loanAmount">
                      <div className="column-one">Loan amount</div>
                      <div className="column-two">
                        {this.state.loanAmount ? parseFloat(this.state.loanAmount.toString(10)).toLocaleString("en-GB", { style:"currency", currency:"GBP" }) : "£0.00"}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="summary-row" key="interestAmount">
                                        <div className="column-one">Interest ({this.state.interestRate ? parseFloat(this.state.interestRate.toString(10)).toLocaleString('en-GB', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                      }) : "0"}%)</div>
                      <div className="column-two">
                        {this.state.interestAmount ? parseFloat(this.state.interestAmount.toString(10)).toLocaleString("en-GB", { style:"currency", currency:"GBP" }) : "£0.00"}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="summary-row" key="totalBorrowed">
                      <div className="column-one bolder">Total borrowed</div>
                      <div className="column-two bolder">
                        {this.state.totalBorrowed ? parseFloat(this.state.totalBorrowed.toString(10)).toLocaleString("en-GB", { style:"currency", currency:"GBP" }) : "£0.00"}
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="summary-row" key="creditLimit">
                      <div className="column-one">Credit limit</div>
                      <div className="column-two">
                        {this.state.creditLimit ? parseFloat(this.state.creditLimit.toString(10)).toLocaleString("en-GB", { style:"currency", currency:"GBP" }) : "£0.00"}
                      </div>
                    </div>
                  </div>

                </div>
              </section>
              
              <section id="terms">
                <div className="container">
                  <div className="container-title">Our Credit Agreement with you</div>
                  <ScrollableContainer>
                    <div id="pdfWrapper" style={{width: "Calc(100% - 20px)"}}>
                      <Document
                        file={`data:application/pdf;base64,${this.state.pdfDoc}`}
                        loading={""}
                        onLoadSuccess={({numPages}) => {
                          this.setNumPages(numPages);
                          this.setState({pdfLoaded:true});
                        }}
                        renderMode="canvas"  
                      >
                      {this.state.pdfLoaded && Array.from(
                          new Array(this.state.numPages),
                          (el, index) => (
                              <Page
                                  loading={""}
                                  width={this.state.width}
                                  key={`page_${index + 1}`}
                                  pageNumber={index + 1}
                                  renderTextLayer={false}
                                  renderForms={false}
                                  renderAnnotationLayer={false}
                              />
                          )
                      )}
                    </Document>
                    </div>  
                    
                  </ScrollableContainer>
                  <div className="downloadPanel">
                    <div className="downloadButton">
                      <a href={"data:application/pdf;base64," + this.state.pdfDoc} download={this.state.pdfFilename + ".pdf"}>
                        <i className="bi bi-download" />&nbsp;Download</a>
                    </div>
                  </div>
                </div>
              </section>              
              <section id="information1">
                <div className="container">
                  <div className="container-title">Before you sign this Credit Agreement</div>
                  <div className="information-row">
                    To enter into this Agreement, you must be aged 18 years or over and a UK resident.
                  </div>
                  <div className="information-row">
                    By entering into the Agreement, you are confirming that you have read and agree to
                    the Pre-contract Credit Information and the Terms and Conditions.
                  </div>
                  <div className="information-row">
                    This Agreement is made on the date you sign it.
                  </div>
                  <div className="information-row">
                    If you are a partnership or limited company, the person signing below confirms that
                    he/she is an authorised signatory. Please note: The Consumer Credit Act 1974 only applies if you are an
                    individual or a partnership of up to three partners.
                  </div>
                </div>
              </section>
              
              <section id="information2">
                <div className="container">
                  <div className="container-title">Our signature</div>
                  <div className="information-row">
                    Signed on behalf of <b>Alan Boswell Insurance Brokers Limited</b> of Prospect House,
                    Rouen Road, Norwich, NR1 1RE.
                  </div>
                  <div className="signature-container">
                    <Image src={SigImage}/>
                  </div>
                  <div className="information-row">
                    Date of signature: {this.state.policyCreateDate}
                  </div>
                </div>
              </section>
              

              
              <section id="consent">
                <div className="container">
                  <div className="container-title">Your e-signature</div>
                  <div className="information-row">
                    This is a Credit Agreement regulated by the Consumer Credit Act 1974. Sign only if
                    you want to be legally bound by its terms.

                  </div>
                  <div className="information-row termsAgreement">
                    <input type="checkbox" id="agreeTerms" className="termsAgreementCheckbox" onClick={_.debounce(this.termTickAction, 1000, {
                      'leading': true,
                      'trailing': false
                    })}                      
                    />
                    <label className="termsAgreementLabel" htmlFor="agreeTerms">By ticking this box,
                      I, {this.state.customerName}, agree to sign this Consumer Credit Agreement
                      electronically and confirm this is a valid means of establishing the authenticity and
                      integrity of my signature to this agreement.</label>
                  </div>
                </div>
              </section>
              
              <section id="buttons">
                <div className="container-no-border">
                  <div className="row">
                    <button
                        className={`ok`}
                        disabled={!this.state.termsTicked}
                        type="button"
                        onClick={_.debounce(this.okAction, 1000, {
                          'leading': true,
                          'trailing': false
                        })}
                    >
                      Accept
                    </button>

                    <button
                        className={`cancel`}
                        type="button"
                        onClick={_.debounce(this.cancelAction, 1000, {
                          'leading': true,
                          'trailing': false
                        })}
                    >
                      Cancel
                    </button>

                  </div>
                </div>
              </section>
              
            </CartSummary>

          </div>
          }
          {!this.state.loading
          && this.state.showCancelContent === true
          && this.state.showSignedContent === false
          && this.state.showAlreadySignedContent === false
          && this.state.showInvalidPolicyContent === false
          &&
          <div style={{paddingBottom: '2em', paddingLeft: '16px', paddingRight: '16px', paddingTop: '2em'}}>
          <CartSummary>
          <section id="cancelled">
            <div className="container">
              <div className="container-title">Your agreement remains un-signed</div>
              <div className="information-row">It looks like you aren’t ready to sign your Credit Agreement just yet.</div>
              <div className="information-row">That’s OK, you can return here to sign it any time by clicking the link in the email we sent you. We will be in touch again to remind you if it remains un-signed.</div>
              <div className="information-row">If you have any questions, or if you have changed your mind and no longer wish to pay by instalments, please contact us immediately on 01603 216395 or email us at <a href={"mailto:instalments@alanboswell.com"}>instalments@alanboswell.com</a>.</div>
            </div>
          </section>
          </CartSummary>  
          </div>
          }
          {!this.state.loading
          && this.state.showCancelContent === false
          && this.state.showSignedContent === true
          && this.state.showAlreadySignedContent === false
          && this.state.showInvalidPolicyContent === false
          &&
          <div style={{paddingBottom: '2em', paddingLeft: '16px', paddingRight: '16px', paddingTop: '2em'}}>
          <CartSummary>
          <section id="signed">
            <div className="container">
              <div className="container-title">Your agreement has been signed</div>
              <div className="information-row">Thank you for signing your Credit Agreement. We will send you an email to confirm this.</div>
              <div className="information-row">If you have any questions, or if you have changed your mind and no longer wish to pay by instalments, please contact us immediately on 01603 216395 or email us at <a href={"mailto:instalments@alanboswell.com"}>instalments@alanboswell.com</a>.</div>
            </div>
          </section>
          </CartSummary>
          </div>
          }
          {!this.state.loading
          && this.state.showCancelContent === false
          && this.state.showSignedContent === false
          && this.state.showAlreadySignedContent === true
          && this.state.showInvalidPolicyContent === false
          &&
          <div style={{paddingBottom: '2em', paddingLeft: '16px', paddingRight: '16px', paddingTop: '2em'}}>
          <CartSummary>
          <section id="alreadySigned">
            <div className="container">
              <div className="container-title">Your agreement is already signed</div>
              <div className="information-row">It looks like your Credit Agreement has already been signed.</div>
              <div className="information-row">If you don’t recall signing the agreement, or if you have changed your mind and no longer wish to pay by instalments, please contact us immediately on 01603 216395 or email us at <a href={"mailto:instalments@alanboswell.com"}>instalments@alanboswell.com</a>.</div>
            </div>
          </section>
          </CartSummary>
          </div>
          }
          {!this.state.loading
          && this.state.showCancelContent === false
          && this.state.showSignedContent === false
          && this.state.showAlreadySignedContent === false
          && this.state.showInvalidPolicyContent === true
          &&
          <div style={{paddingBottom: '2em', paddingLeft: '16px', paddingRight: '16px', paddingTop: '2em'}}>
          <CartSummary>
            <section id="invalidPolicy">
              <div className="container">
                <div className="container-title">Sorry</div>
                <div className="information-row">We can't find a Credit Agreement with that link.</div>
                <div className="information-row">Please try again with a different link, or if you have any questions please contact us immediately on 01603 216395 or email us at <a href={"mailto:instalments@alanboswell.com"}>instalments@alanboswell.com</a>.</div>
              </div>
            </section>
          </CartSummary>
          </div>
          }
        </React.Fragment>
    );
  }
}

const SpinnerContainer = styled.div`
 display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
  
`
const ScrollableContainer = styled.div`
  max-width: 428px;
  margin-top: 0px;
  margin-right: auto;

  margin: 0 auto;
  font-family: "Figtree-Standard",sans-serif !important;
  -webkit-font-smoothing: antialiased;
  

  @media only screen and (max-width: 640px) {
    max-width: 396px;
    margin-left:auto;
    margin-right:auto;
    width:100%;
  }

  @media only screen and (max-width: 428px) {
    max-width: 328px;
  }
    
  height:400px;
  overflow-y:auto;
  overflow-x:hidden;  
  
  .react-pdf__Page canvas
  {
  width:100% !important;
  }
      
`
const CartSummary = styled.div`
#order-summary, #terms, #consent, #buttons, #information1, #information2, #cancelled, #signed, #alreadySigned,#invalidPolicy
{
  max-width: 428px;
  margin-top: 0px;
  margin-right: auto;

  margin: 0 auto;
  font-family: "Figtree-Medium", sans-serif !important;
  -webkit-font-smoothing: antialiased;
 
  @media only screen and (max-width: 640px) {
    max-width: 396px;
    margin-left:auto;
    margin-right:auto;
    width:100%;
  }
  
  @media only screen and (max-width: 428px) {
    max-width: 328px;
    margin-left:auto;
    margin-right:auto;
  }


  
  .information-row
  {
    padding-bottom:20px;
  }
  
  .information-row.termsAgreement
  {
    display:grid;
    align-content: stretch;
    justify-content: space-between;
    align-items: start;
    justify-items: stretch;
    grid-template-columns: 40px auto;
  }
  
  .information-row.termsAgreement #agreeTerms
  {
    width:20px;
    height:20px;
  }
  .information-row.termsAgreement .termsAgreementLabel
  {
  
  }
  
  .signature-container
  {
    text-align:center;
    padding-bottom:20px;
  }
  .signature-container img
  {
    margin:0px auto;
    
  }
}

#cancelled, #signed, #alreadySigned,#invalidPolicy
{
  margin-top:40px;
}

#buttons
{
  text-align:center;
}


 .downloadPanel
 {
  max-width: 428px;
  margin-top: 0px;
  margin-right: auto;

  margin: 0 auto;
  font-family: "Figtree-Standard",sans-serif !important;
  -webkit-font-smoothing: antialiased;
  
  padding: 16px;
  margin: 0px;
  border-top: 2px solid #dae2e8;
 
  @media only screen and (max-width: 640px) {
    max-width: 396px;
    margin-left:auto;
    margin-right:auto;
    width:100%;
  }
  
  @media only screen and (max-width: 428px) {
    max-width: 328px;
  }
 }
 
.downloadButton
{
  display:inline-block;
  background-color:#14406d;
  color:#fff;
  padding:10px 20px;
  border-radius:0px;
  cursor:pointer;
}

.downloadButton:hover
{
  background-color:#385c83;
}

.downloadButton a:link,
.downloadButton a:visited,
.downloadButton a:hover,
.downloadButton a:active
{
  color:#fff;
  text-decoration:none;
}
            
button.right {
  height: 25px;
  line-height: 8px;
  float: right;
}


#order-summary textarea,
#order-summary input, 
#terms textarea,
#terms input
{
  padding: 10px;
  margin: 0px;
  border: 1px solid rgba(34,36,38,0.15);
  width: 100%;
  border-radius: 5px;
  background-color: lightgray;
  height: 130px;
  font-size: 0.85em;
  color:#103f6f;
}

textarea {
  border-radius: inherit;
}

input {
  background-color: inherit;
  height: inherit;
}

button
{
  font-family:'Figtree-Medium';
  font-style: normal;
  font-weight: normal;
}

#order-summary,#information1, #information2
{
  background-color: #f5f8f9;
  font-family: "Figtree-Standard" !important;
  -webkit-font-smoothing: antialiased;
}

.container {
  border: 4px solid #dae2e8;
  margin: 0 0 16px 0;
  padding: 16px 16px 16px 16px !important;
  color: rgb(16, 63, 111);

  .container-title {
    font-family: 'Figtree-Medium';
    text-align: left;
    font-size: 17px;
    font-weight: normal;  
    margin-bottom:19px;
  }
}

.container-no-border {  
  margin: 0 0 16px 0;
  padding: 16px 16px 4px 16px !important;
  color: rgb(16, 63, 111);
}
  
@media (min-width: 320px) {
  padding: 0px 0px 8px 0px;
}

.column-one {
  display: inline-block;
  width: 70%;
}

.column-two {
  display: inline-block;
  width: 30%;
  text-align: right;
}

.column-one.left {
  width: 50%;
}

.column-two.left {
  text-align: left;
  width: 50%;
}

.column-one.bolder {  
  margin-top:17px;
    font-family: 'Figtree-Medium';
    font-size: 17px;
    font-weight: normal;  
}
.column-two.bolder {
margin-top:17px;  
    font-family: 'Figtree-Medium';
    font-size: 17px;
    font-weight: normal;  
}

#terms .container {
    border: 4px solid #dae2e8;
    margin: 0 0 16px 0;
    padding: 0px !important;
    color: rgb(16, 63, 111);
}
  
#terms .container-title
{
  padding: 16px 16px 16px 16px !important;
  border-bottom:1px solid #dae2e8;
  margin-bottom:0px;
}
  
#consent .container
{
  border: 4px solid #B41519;
}


#buttons
{
  button {
    background-color: #21ba56;
    color: #fff;
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
    cursor: pointer;
    display: inline-block;
    min-height: 1em;
    outline: 0;
    border: none;
    vertical-align: baseline;

    &[disabled] {
      opacity: 0.5;
      cursor: default;
    }
  }
  
  button.ok
  {
    margin-bottom:8px;
  }
  
  button.cancel
  {
    background-color:#e0e0e0;
    color:#424242;    
  }

}
`;


export default connect(
    (state: ApplicationState) => ({ customer: state.customer }),
    actionCreators
)(CCAViewer);
